import { spUsersApi } from './spusers';

export const smsOptOutApi = spUsersApi.injectEndpoints({
  endpoints: (builder) => ({

    smsOptOut: builder.mutation({
      query: () => ({
        url:    '/phone/opt-out',
        method: 'POST',
        body:   {},
      }),
      invalidatesTags: ['phoneVerification'],
    }),

  }),
  overrideExisting: false,
});

export const { useSmsOptOutMutation } = smsOptOutApi;